import React from "react";
import { HeartFilled } from "@ant-design/icons";

const CopyRight = () => (
  <p className="copyright">
    © 2021, made with{<HeartFilled />}by asinzen team. Version{" "}
    {process.env.REACT_APP_BUILD_NUMBER}
  </p>
);

export default CopyRight;
